import React from 'react';
import { isHTML } from '../../utils/helpers';

const ShowMoreShowLessText = ({ text, visibility = 30, customClass = '' }) => {
  const [isshowingMore, setIsShowingMore] = React.useState(false);
  const isHTMLValue = isHTML(text);

  if (isHTMLValue) {
    return <div dangerouslySetInnerHTML={{ __html: text }} />;
  }

  return (
    <span>
      {text?.substring(0, isshowingMore ? text.length : visibility)}
      {text?.length > visibility && !isshowingMore && '...'}{' '}
      {text?.length > visibility && (
        <span
          onClick={() => setIsShowingMore((p) => !p)}
          className={customClass}
          style={{
            color: '#484848a6',
            fontWeight: '400',
            fontSize: '14px',
            cursor: 'pointer'
          }}>
          {isshowingMore ? 'Show Less' : 'Show More'}
        </span>
      )}
    </span>
  );
};

export default ShowMoreShowLessText;
